((window as unknown) as {
  process: { env: Record<string, string> };
}).process = ((window as unknown) as {
  process?: { env: Record<string, string> };
}).process || { env: {} };

import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';
import 'allsettled-polyfill';
import 'intersection-observer';
import 'scrollyfills';
import 'focus-within-polyfill';
import 'abortcontroller-polyfill/dist/polyfill-patch-fetch';
import globalThisPolyfill from 'globalthis';
import { enableES5 as enableES5ForImmer } from 'immer';
import JSBI from 'jsbi';

// on older Tizen tv:s (2019 and older) we need to polyfill BigInt
// Without this we cant redirect the users to the legacy app
if (typeof BigInt === 'undefined') {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  window.BigInt = JSBI.BigInt;
}

globalThisPolyfill.shim();

// Apollo Client 4 uses FinalizationRegistry + WeakRef for cache GC hints (Chrome 84+).
// 2020 Samsung (Tizen 5.5 / Chrome 76) and 2020-2021 LG (webOS 5-6 / Chrome 68-79) lack
// these — stub as no-ops so Apollo loads. Cost: missed GC hints (cache eviction is
// timer-driven as well, so functionally OK).
const globals = (window as unknown) as Record<string, unknown>;
if (typeof globals.FinalizationRegistry === 'undefined') {
  globals.FinalizationRegistry = class {
    register() {}
    unregister() {}
  };
}
if (typeof globals.WeakRef === 'undefined') {
  globals.WeakRef = class<T> {
    constructor(private target: T) {}
    deref(): T {
      return this.target;
    }
  };
}

// Prevent crash on older samsungs <= 2017 etc. Maybe this can be removed laster
enableES5ForImmer();

// Fix Apollo Client 3 __DEV__
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
if (typeof globalThis.__DEV__ !== 'boolean') {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  globalThis.__DEV__ = false;
}
